/** @jsx jsx */

import { PropsWithChildren } from 'react';

import { Colors } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  content: css`
    margin: 0 auto;
    width: 420px;
  `,
  root: css`
    background-color: ${Colors.GrayWarm2};
    height: calc(100vh + 69px);
  `,
  wrapper: css`
    background-color: ${Colors.PrimeWhite};
    border: 1px solid ${Colors.GrayWarm3};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    margin: 45px auto;
    padding-bottom: 50px;
    padding-top: 50px;
    width: 959px;
  `,
};

type Props = PropsWithChildren<{ className?: string }>;

function Page(props: Props) {
  const { children, className } = props;

  return (
    <div className={className} css={Styles.root}>
      <div css={Styles.wrapper}>
        <div css={Styles.content}>{children}</div>
      </div>
    </div>
  );
}

export default Page;
